const isExpiredPromo = expiryTimestamp => new Date().getTime() > expiryTimestamp;

export {
    isExpiredPromo
};
